export default __webpack_public_path__ + "static/media/TER2.20254f2e.jpg";